import {LATESTACTION_UPDATED, PURCHASE_ORDER_LOADED} from "./ActionType";

export default function purchaseOrderReducer(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case PURCHASE_ORDER_LOADED:
      return (state = payload);

    case LATESTACTION_UPDATED:
      var cloneStorage = [...state]
      for (let i = 0; i < cloneStorage.length; i++) {
        if (cloneStorage[i].POID === payload.POID) {
          cloneStorage[i] = {
            ...cloneStorage[i],
            LatestAction: payload.LatestAction
          }
          break;
        }
      }
      return cloneStorage

    default:
      return state;
  }
}
